import * as React from 'react';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import './Alert.css';

export default function Alerts({ message, severity }) {
  return (
    <Stack
      sx={{
        width: 'auto',
        position: 'fixed',
        bottom: 16,
        right: 16,
        zIndex: 1000,
        marginRight:'65px'
      }}
      spacing={2}
    >
      <Alert className='alert' variant="outlined" severity={severity}>
        {message}
      </Alert>
    </Stack>
  );
}
